import { render, staticRenderFns } from "./UsuarioUpdate.vue?vue&type=template&id=27b8cc1e&"
import script from "./UsuarioUpdate.vue?vue&type=script&lang=js&"
export * from "./UsuarioUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports